import {
  getEnv,
  getUA,
  converUrlParamsObj,
  getLocationVars
} from '@/utils/utils'

// 接口域名
const apiUrlList = {
  dev: 'https://dev-feedback-api-sz.stardustgod.com',
  test: 'https://dev-feedback-api-sz.stardustgod.com',
  prod: 'https://feedback-api.stardustgod.com',
  gray: 'https://dev_feedback_api_sz.stardustgod.com'
}
export const apiUrl: string = apiUrlList[getEnv()]
const dramaUrl = {
  dev: '',
  test: 'https://dev-feedback-api-sz.b25drama.com',
  prod: 'https://feedback-api.b25drama.com',
  gray: 'https://dev-feedback-api-sz.b25drama.com'
}
export const apiUrlDrama: string = dramaUrl[getEnv()]

// app应用地址
export const appUploadAddress: { [key: string]: any } = {
  // Chapeter
  cm1001: {
    ios:
      'https://apps.apple.com/us/app/chapters-interactive-stories/id1277029359',
    android:
      'https://play.google.com/store/apps/details?id=com.mars.avgchapters'
  },
  // Spotlight
  cm1002: {
    ios:
      'https://apps.apple.com/us/app/spotlight-choose-your-romance/id1511550641',
    android:
      'https://play.google.com/store/apps/details?id=com.stardust.spotlight&hl=en&gl=US'
  },
  // Kiss
  cm1003: {
    ios: 'https://apps.apple.com/app/id1508942129',
    android:
      'https://play.google.com/store/apps/details?id=com.stardust.kissreader'
  },
  // Project-J1 (PWK)
  cm1006: {
    ios: '',
    android:
      'https://play.google.com/store/apps/details?id=com.crazymaplestudio.pwk'
  },
  // Project-J2 (Magic)
  cm1007: {
    ios: '',
    android:
      'https://play.google.com/store/apps/details?id=com.maplehouse.gp.magic'
  },
  // Escape
  cm1008: {
    ios:
      'https://apps.apple.com/us/app/escape-interactive-stories/id1592622967',
    android: 'https://play.google.com/store/apps/details?id=com.mars.escape'
  },
  // Project-V (Reelshort App)
  cm1009: {
    ios: 'https://apps.apple.com/us/app/reelshort/id1636235979',
    android:
      'https://play.google.com/store/apps/details?id=com.newleaf.app.android.victor'
  },
  // Project-V H5 (ReelShort H5 主站)
  cm1017: {
    ios: 'https://apps.apple.com/us/app/reelshort/id1636235979',
    android:
      'https://play.google.com/store/apps/details?id=com.newleaf.app.android.victor'
  },
  // MatchMe
  cm1011: {
    ios: 'https://apps.apple.com/app/id1592622967',
    android:
      'https://play.google.com/store/apps/details?id=com.maplehouse.gp.ichat.aa'
  },
  // MaxDrama
  cm1012: {
    ios: 'https://apps.apple.com/app/id6739766329',
    android: 'https://play.google.com/store/apps/details?id=com.b25drama.android.app'
  },
  // RS Novel
  cm1013: {
    ios: 'https://apps.apple.com/app/id6636532586',
    android:
      'https://play.google.com/store/apps/details?id=com.reelshortnovel.reader'
  },
  // Gorogoro
  cm1018: {
    ios: '', // TODO: add Gorogoro App Store link
    android: '' // TODO: add Gorogoro Google Play link
  },
  // MergeWorld
  cm1015: {
    ios: 'https://apps.apple.com/app/id6745001036',
    android:
      'https://play.google.com/store/apps/details?id=com.b25game.win.gp'
  },
  // Myfiction
  cm3002: {
    ios: 'https://apps.apple.com/app/id1508942129',
    android:
      'https://play.google.com/store/apps/details?id=com.stardust.kissreader'
  },
}
